<template>
    <div class="login">
       <img alt="Vue logo" src="../assets/logo.gif">
      <!-- <div v-if="loading" class="loader"><span>Loading</span></div> -->
      <h1>Employee portal</h1>
      <div class="content">
        <div class="field">
          <label for="partnerNumber">Partner Number: </label>
          <input id='partnerNumber' v-model="partnerNumber" type="text"><br>
        </div>
        <div class="field">
          <label for="password">Password: </label>
          <input id='password' v-model="password" type="password"><br>
        </div>
        
        <button @click="login()">Log in</button>
        <div class="message">{{message}}</div>
      </div>
      <div class="forgetPassword">
        Please contact your manager to retrive your password.
      </div>
    </div>
  </template>
  
  <script>
  import Cookies from 'js-cookie'
  export default {
    name: 'LogIn',
    props: {
      msg: String,
    },
    data() {
      return {
        message:'',
        partnerNumber: '',
        password: '',
        // partnerNumber: '019099',
        // password: '198809123629 ',
        apiURL: ''
      }
    },
    methods: {
      login() {
        // Implement login logic here
        if(this.partnerNumber.trim() === '' || this.password.trim() === '') {
          this.message = 'Please enter both partner number and password.';
          return;
        }
        console.log('Logging in with', this.partnerNumber, this.password);
        // You can use this.$router to navigate to another view after login 
        // this.$router.push('/dashboard'); 
        // this.loading = true;
        this.$emit('displayGlobalMessage', {message:'Logging in.', on: true})
        // this.axios.post('http://localhost:3000/login', {
        this.axios.post(process.env.VUE_APP_API_BASE_URL+"/login", {
          partner_number: this.partnerNumber.trim(),
          password: this.password.trim()
        }).then(response => {
          console.log('Login successful:', response.data);
          // Handle successful login, e.g., redirect to dashboard
          if(response.data.success) {
            // this.$router.push('/dashboard');
            console.log('Token:', response.data.data.token);
            this.setSiteCookie('btoken', response.data.data.token);
            localStorage.setItem(response.data.data.token, JSON.stringify(response.data.data.employee))
            this.$router.push({ path: '/'})
          } else {
            this.message = 'Login failed. Please try again.';
          }
          this.$emit('displayGlobalMessage', {message:'Logging in.', on: false})
          this.$emit('login')
          //  this.loading = false;
        })
      },
      setSiteCookie(name, value) {
        console.log(name, value)
        Cookies.set(name, value, '7D'); // Set for 1 day
      },
      // getSiteCookie(name) {
      //   const value = Cookies.get(name);
      //   console.log(value);
      //   return value
      // },
      // removeSiteCookie(name) {
      //   Cookies.remove(name);
      // }
    },
    mounted() {
      this.apiURL = process.env.NODE_ENV == 'development' ? 'http://localhost:3000' : `/api/`
      console.log('LoginView mounted');
      // if(this.getSiteCookie('token') != undefined) {
      //   this.checkAlive ()

      // } else {
      //   console.log('No token found, stay on login page');
      // }
    }
  }  
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped lang="scss">
  
  .login{
    padding:60px;
    display:block;
    .message{
      color: red;
      font-weight: bold;
      margin-top: 10px;
      text-align: center;
      text-transform: uppercase;
    }
    .content{
      display:block;
      margin: 0 auto;
      padding:0px 50px 0px 50px;
    }
    .loader {
      /* display: none; */
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      z-index: 9999;
      text-align: center;
      font-size: 24px;
      color: #333;
      span {
        position: absolute;
        top: 10%;
        left: 50%;
        color:#d86c8e;
        width: 100%;
        transform: translate(-50%, -50%);
      }
    }
  }

  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .login{
    display:block;
    .content{
      .field{
        label{

          width: 140px;
          display: inline-block;
          margin: 0 auto;
          text-align: right;
          margin-right:10px
        }
      }
      button{
        margin: 32px auto;
        height:35px;
        width:250px;
      }
    }
  }

  </style>
  